/**
 * Поле meta в БД — обычный текст description
 * или JSON с полями, как в шаблоне админки.
 */

const JSON_KEYS = {
  description: ['description'],
  appleMobileWebAppTitle: ['appleMobileWebAppTitle', 'apple-mobile-web-app-title'],
  applicationName: ['applicationName', 'application-name'],
  msapplicationTileColor: ['msapplicationTileColor', 'msapplication-TileColor'],
  themeColor: ['themeColor', 'theme-color'],
}

function pick(obj, aliases) {
  if (!obj || typeof obj !== 'object') return undefined
  for (const key of aliases) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue
    const value = obj[key]
    if (value == null || String(value).trim() === '') continue
    return String(value).trim()
  }
  return undefined
}

export function parseSeoMetaField(raw) {
  const text = raw == null ? '' : String(raw).trim()
  if (!text) return { description: '', isJson: false }

  if (text[0] === '{' || text[0] === '[') {
    try {
      const parsed = JSON.parse(text)
      const root = Array.isArray(parsed) ? parsed[0] : parsed
      if (root && typeof root === 'object') {
        return {
          description: pick(root, JSON_KEYS.description) || '',
          appleMobileWebAppTitle: pick(root, JSON_KEYS.appleMobileWebAppTitle),
          applicationName: pick(root, JSON_KEYS.applicationName),
          msapplicationTileColor: pick(root, JSON_KEYS.msapplicationTileColor),
          themeColor: pick(root, JSON_KEYS.themeColor),
          isJson: true,
        }
      }
    } catch (e) {
      // обычный текст description
    }
  }

  return { description: text, isJson: false }
}
